import { ComponentProps, useCallback } from 'react';
import { Content } from 'src/contexts/ContentContext';
import { DialogId } from 'src/contexts/DialogContext/DialogContext';
import { useDialog } from 'src/contexts/DialogContext/useDialog';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { vars } from 'src/core/themes';
import { Button } from 'src/core/ui';
import { useBasicDialog } from 'src/hooks/useBasicDialog';
import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { IconsFill, UploadIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature, Permission } from 'src/WebApiController';

import { BulkUploadSeatSaversDialog } from './BulkUploadSeatSaversDialog';

export type LaunchBulkUploadSeatSaversDialogProps = ComponentProps<
  typeof Button
> & { className?: string };

export const LaunchBulkUploadSeatSaversDialog = ({
  variant = 'link',
  ...props
}: LaunchBulkUploadSeatSaversDialogProps) => {
  const hasPermission = useUserHasAnyOfPermissions(
    Permission.Inventory_AddSeatSaver
  );
  const hasSeatSaverFeature = useUserHasFeature(Feature.SeatSaver);

  const bulkUploadSeatSaversDialog = useBasicDialog();

  const {
    openDialog: openBulkUploadSeatSaversDialog,
    closeDialog: closeBulkUploadSeatSaversDialog,
  } = useDialog(DialogId.BulkUploadSeatSavers, BulkUploadSeatSaversDialog);

  const onBulkUploadSeatSavers = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      openBulkUploadSeatSaversDialog({
        ...bulkUploadSeatSaversDialog.dialogProps,
        onClosed: closeBulkUploadSeatSaversDialog,
        onCancel: closeBulkUploadSeatSaversDialog,
      });
      bulkUploadSeatSaversDialog.launchDialog();
    },
    [
      bulkUploadSeatSaversDialog,
      closeBulkUploadSeatSaversDialog,
      openBulkUploadSeatSaversDialog,
    ]
  );

  if (!hasPermission || !hasSeatSaverFeature) {
    return null;
  }

  return (
    <>
      <PosDropdownItem
        key="bulkUploadSeatSavers"
        onClick={onBulkUploadSeatSavers}
        disabled={props.disabled}
      >
        <UploadIcon
          withHoverEffect
          fill={IconsFill.currentColor}
          size={vars.iconSize.s}
        />
        <Content id={ContentId.BulkUploadSeatSavers} />
      </PosDropdownItem>
    </>
  );
};
